import { render, staticRenderFns } from "./SidebarSearchPanel.vue?vue&type=template&id=097b55d4&scoped=true"
import script from "./SidebarSearchPanel.vue?vue&type=script&lang=js"
export * from "./SidebarSearchPanel.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearchPanel.vue?vue&type=style&index=0&id=097b55d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b55d4",
  null
  
)

export default component.exports